/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The DashboardStatsSurgeriesThisWeek model module.
 * @module model/DashboardStatsSurgeriesThisWeek
 * @version v0.3
 */
export default class DashboardStatsSurgeriesThisWeek {
  /**
   * Constructs a new <code>DashboardStatsSurgeriesThisWeek</code>.
   * @alias module:model/DashboardStatsSurgeriesThisWeek
   * @class
   * @param total {Number}
   * @param today {Number}
   * @param tomorrow {Number}
   */
  constructor(total, today, tomorrow) {
    this.total = total;
    this.today = today;
    this.tomorrow = tomorrow;
  }

  /**
   * Constructs a <code>DashboardStatsSurgeriesThisWeek</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/DashboardStatsSurgeriesThisWeek} obj Optional instance to populate.
   * @return {module:model/DashboardStatsSurgeriesThisWeek} The populated <code>DashboardStatsSurgeriesThisWeek</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new DashboardStatsSurgeriesThisWeek();
      if (data.hasOwnProperty('total'))
        obj.total = ApiClient.convertToType(data['total'], 'Number');
      if (data.hasOwnProperty('today'))
        obj.today = ApiClient.convertToType(data['today'], 'Number');
      if (data.hasOwnProperty('tomorrow'))
        obj.tomorrow = ApiClient.convertToType(data['tomorrow'], 'Number');
    }
    return obj;
  }
}

/**
 * @member {Number} total
 */
DashboardStatsSurgeriesThisWeek.prototype.total = undefined;

/**
 * @member {Number} today
 */
DashboardStatsSurgeriesThisWeek.prototype.today = undefined;

/**
 * @member {Number} tomorrow
 */
DashboardStatsSurgeriesThisWeek.prototype.tomorrow = undefined;
